import React from 'react';

type AsChildContextValue = {
  hasAsChildParent?: boolean;
};

const AsChildContext = React.createContext<AsChildContextValue | undefined>(
  undefined,
);

type AsChildProviderProps = {
  hasAsChildParent?: boolean;
  children: React.ReactNode;
};

export const AsChildContextProvider = ({
  hasAsChildParent,
  children,
}: AsChildProviderProps) => {
  return (
    <AsChildContext.Provider value={{ hasAsChildParent }}>
      {children}
    </AsChildContext.Provider>
  );
};

AsChildContextProvider.displayName = 'AsChildContextProvider';

export const useAsChild = (): AsChildContextValue => {
  const context = React.useContext(AsChildContext);
  if (!context) {
    return {
      hasAsChildParent: false,
    };
  }
  return context;
};
